import axios from "axios";
export default {
  data() {
    return {
      carregamentoHeader: false,
      carregamentoPagina: false,
      loading: false,
      urlSair: ""
    };
  },
  created() {
    this.init();
  },
  methods: {
    /**
     * TODO: limpar essa função
     */
    init() {
      this.loading = true;
      this.carregamentoHeader = false;
      this.carregamentoPagina = false;
      this.$store.commit("setLoadingModal", true);
      // this.$store.commit("recuperarToken");
      // this.$store.commit("recuperarDadosUsuario");
      this.carregarInformacoes();
    },
    carregarInformacoes() {
      axios
        .get(process.env.BASE_URL + "assets/config.json")
        .then(response => {
          this.$appConfig = { config: response.data };
          this.urlSair = response.data.URL_SAIR;
          this.$store.commit("setAPI", response.data.API);
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
          this.carregamentoPagina = true;
          this.loading = false;
          let pathLogin = window.location.pathname.endsWith("login");
          if (!pathLogin) {
            this.carregamentoHeader = true;
          }
        });
    }
  }
};
